export default __webpack_public_path__ + "assets/models/72ffd9f2722836796aecde2520bfa322.glb";